// extracted by mini-css-extract-plugin
module.exports = {"collection":"TagCollection_collection__3Bj_x","expanded":"TagCollection_expanded__3MK2r","collectionTag":"TagCollection_collectionTag__1EMPo"};